var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          staticClass: "new-event-dialog",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.viewEventDialogVisible,
            "modal-append-to-body": false,
            width: "auto",
          },
          on: {
            "update:visible": function ($event) {
              _vm.viewEventDialogVisible = $event
            },
            open: _vm.onOpen,
            closed: _vm.onClosed,
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-lr" },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Subject" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", placeholder: "Subject" },
                                model: {
                                  value: _vm.form.input,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "input", $$v)
                                  },
                                  expression: "form.input",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "date-time", attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Start Datetime" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "date-picker",
                                attrs: {
                                  disabled: "",
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: "Select date",
                                  editable: false,
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.form.startDateTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "startDateTime", $$v)
                                  },
                                  expression: "form.startDateTime",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c("el-time-select", {
                                ref: "startTime",
                                staticClass: "time-selecter",
                                attrs: {
                                  disabled: "",
                                  editable: false,
                                  placeholder: "Select period",
                                  "value-format": "HH:mm",
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.startSelectTime,
                                  callback: function ($$v) {
                                    _vm.startSelectTime = $$v
                                  },
                                  expression: "startSelectTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "date-time", attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "End Datetime" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "date-picker",
                                attrs: {
                                  disabled: "",
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: "Select date",
                                  editable: false,
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.form.endDateTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "endDateTime", $$v)
                                  },
                                  expression: "form.endDateTime",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c("el-time-select", {
                                ref: "startTime",
                                staticClass: "time-selecter",
                                attrs: {
                                  disabled: "",
                                  editable: false,
                                  placeholder: "Select period",
                                  "value-format": "HH:mm",
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.endSelectTime,
                                  callback: function ($$v) {
                                    _vm.endSelectTime = $$v
                                  },
                                  expression: "endSelectTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Description" } },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea", rows: 4 },
                                model: {
                                  value: _vm.form.content,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "content", $$v)
                                  },
                                  expression: "form.content",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-wrapper" },
                [
                  _c(
                    "el-table",
                    { attrs: { data: _vm.seList } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "Name",
                          label: "SE/CE Name",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "City",
                          label: "City",
                          "min-width": "90",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "Hospital",
                          label: "Hospital / Institution",
                          "min-width": "180",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "Department",
                          label: "Department",
                          "min-width": "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "MLName",
                          label: "MSL Name",
                          "min-width": "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "TeamName",
                          label: "Team",
                          "min-width": "80",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onClosed } },
                [_vm._v(" close ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }